import Marquee from "react-fast-marquee";

const EVENTS = [
    {
        src: "https://posthog-cyan.vercel.app/events/uoe-hackathon.png",
        label: "UoE · Vercel Hackathon",
    },
    {
        src: "https://posthog-cyan.vercel.app/events/uoelast.jpg",
        label: "UoE Finale",
    },
    {
        src: "https://posthog-cyan.vercel.app/events/mamuza-session.png",
        label: "Mamuza Build Session",
    },
    {
        src: "https://posthog-cyan.vercel.app/events/egerhacks.jpg",
        label: "Egerton Hacks",
    },
    {
        src: "https://posthog-cyan.vercel.app/events/v1.jpg",
        label: "Build Bout · v1",
    },
    {
        src: "https://posthog-cyan.vercel.app/events/v2.jpg",
        label: "Build Bout · v2",
    },
];

export default function Gallery() {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative py-20 md:py-32 bg-[#FAFAFA]"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 mb-12 md:mb-16">
                <div className="flex items-end justify-between flex-wrap gap-6">
                    <div className="max-w-2xl">
                        <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-5">
                            <span className="h-px w-8 bg-zinc-400" />
                            Proof of work
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-[-0.03em] text-zinc-950 leading-[0.95]">
                            Our field notes.
                        </h2>
                    </div>
                    <a
                        href="https://photos.app.goo.gl/ZDwmfqsi6rUwDP6g9"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="gallery-see-all"
                        className="inline-flex items-center gap-2 h-11 px-5 rounded-full border border-black/10 bg-white text-sm font-medium text-zinc-900 hover:bg-zinc-950 hover:text-white hover:border-zinc-950 transition-colors"
                    >
                        See the full archive →
                    </a>
                </div>
            </div>

            <Marquee
                gradient={false}
                speed={32}
                pauseOnHover
                className="py-2"
            >
                {EVENTS.map((e, i) => (
                    <GalleryCard key={`${e.label}-a-${i}`} {...e} index={i} />
                ))}
                {EVENTS.map((e, i) => (
                    <GalleryCard key={`${e.label}-b-${i}`} {...e} index={i} />
                ))}
            </Marquee>

            <Marquee
                gradient={false}
                speed={26}
                direction="right"
                pauseOnHover
                className="py-2 mt-3"
            >
                {[...EVENTS].reverse().map((e, i) => (
                    <GalleryCard key={`${e.label}-r1-${i}`} {...e} index={i} />
                ))}
                {[...EVENTS].reverse().map((e, i) => (
                    <GalleryCard key={`${e.label}-r2-${i}`} {...e} index={i} />
                ))}
            </Marquee>
        </section>
    );
}

function GalleryCard({ src, label, index }) {
    return (
        <figure
            data-testid={`gallery-item-${index}`}
            className="group relative mx-2 md:mx-3 w-[280px] sm:w-[360px] md:w-[460px] aspect-[4/3] rounded-2xl overflow-hidden bg-zinc-200 shrink-0"
        >
            <img
                src={src}
                alt={label}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
            />
            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                <figcaption className="text-white text-sm font-medium tracking-wide">
                    {label}
                </figcaption>
            </div>
        </figure>
    );
}
